import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Invoice from '../../helper/Invoice'

function BillingDetails() {

    const [paymentsUnsorted, setPaymentsUnsorted] = useState([])
    // const [payments, setPayments] = useState([])

    useEffect(()=>{
        axios.get("https://dealersonly.parts/beta/api/user/billing")
          .then(res => {
            setPaymentsUnsorted(res.data)
          })
          .catch((error) => {
            console.log(error);
          })
      },[])


      const formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
      });

       function groupBy(key) {
        return function group(array) {
            return array.reduce((acc, obj) => {
            const property = obj[key];
            acc[property] = acc[property] || [];
            acc[property].push(obj);
            return acc;
            }, {});
        };
        }
      
        const groupByYear = groupBy("month");
    
        let payments = []
    
        let sortedArray = groupByYear(paymentsUnsorted)
        
        Object.keys(sortedArray).forEach(element => {
            let sum = 0.0 
            let count = 0
            sum = sortedArray[element].reduce((accumulator, object) => {
                return parseFloat(accumulator) + parseFloat(object.fee);
              }, 0);
            count = sortedArray[element].reduce((accumulator, object) => {
            return accumulator + object.count;
            }, 0); 
            
            payments.unshift({monat: sortedArray[element][0].date, artikel: count, amount: formatter.format(sum)})
            // setPayments(state => [...state, {monat: sortedArray[element][0].date, artikel: count, amount: formatter.format(sum)}])
            
        });  

  return (
    <div>
        <section aria-labelledby="billing-history-heading">
                <div className="bg-white pt-6 shadow sm:overflow-hidden sm:rounded-md">
                  <div className="px-4 sm:px-6">
                    <h2 id="billing-history-heading" className="text-lg font-medium leading-6 text-gray-900">
                      Abrechnungen
                    </h2>
                  </div>
                  <div className="mt-6 flex flex-col">
                    <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                        <div className="overflow-hidden border-t border-gray-200">
                          <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                              <tr>
                                <th scope="col" className="px-6 py-3 text-left text-sm font-semibold text-gray-900">
                                  Datum
                                </th>
                                <th scope="col" className="px-6 py-3 text-left text-sm font-semibold text-gray-900">
                                  Beschreibung
                                </th>
                                <th scope="col" className="px-6 py-3 text-left text-sm font-semibold text-gray-900">
                                  Summe
                                </th>
                                {/*
                                  `relative` is added here due to a weird bug in Safari that causes `sr-only` headings to introduce overflow on the body on mobile.
                                */}
                                <th
                                  scope="col"
                                  className="relative px-6 py-3 text-left text-sm font-medium text-gray-500"
                                >
                                  <span className="sr-only">Anzeigen</span>
                                </th>
                              </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200 bg-white">
                              {payments?.map((payment) => (
                                <tr key={payment.id}>
                                  <td className="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900">
                                    <time dateTime={payment.datetime}>{payment.monat}</time>
                                  </td>
                                  <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                                    D.O.P.E Gebühren {payment.monat.split(" ")[0]}
                                  </td>
                                  <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                                    {payment.amount}
                                  </td>
                                  <td className="whitespace-nowrap px-6 py-4 text-right text-sm font-medium">
                                    <Link to={`bill/${payment.monat.toLowerCase().replace(' ','-')}`} className="text-blue-600 hover:text-blue-900">
                                      Anzeigen
                                    </Link>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
  )
}

export default BillingDetails